import RelativeTimestamp from './relative-timestamp';

export default RelativeTimestamp;
